export default __webpack_public_path__ + "static/logo3-9e46fb67a8421285b0433c94dbfe068f.png";